enum BraintreeTokenizedPaymentMethodTypeEnum {
    CREDIT_CARD = "CreditCard",
    PAYPAL = "PayPalAccount",
}

export default BraintreeTokenizedPaymentMethodTypeEnum;
